var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTorus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.395,
    height: 57.829,
    viewBox: "0 0 53.395 57.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.4 -39.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8,39.5a5.388,5.388,0,0,0-5.4,5.4v6.361a5.388,5.388,0,0,0,5.4,5.4h9.638V91.931a5.388,5.388,0,0,0,5.4,5.4h6.361a5.388,5.388,0,0,0,5.4-5.4V51.258h0V44.9a5.388,5.388,0,0,0-5.4-5.4H23.8Z",
    fill: "#155fcc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.782,56.563a8.432,8.432,0,0,0,8.482-8.482A8.557,8.557,0,0,0,45.782,39.6,8.432,8.432,0,0,0,37.3,48.082,8.557,8.557,0,0,0,45.782,56.563Z",
    transform: "translate(17.532 0.093)",
    fill: "#155fcc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorus);
export default __webpack_public_path__ + "static/media/Torus.26ed4bf09510e713a987ebe748f4db8a.svg";
export { ForwardRef as ReactComponent };